module.exports = __webpack_public_path__ + "static/media/screenshot.9cb82787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/YwamShowcaseBrowser/screenshot.jpg
// module id = 234
// module chunks = 0